import React from 'react';

interface ProgressIndicatorProps {
  label: string;
  progress: number; // 0-100
  isComplete?: boolean;
  isError?: boolean;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ 
  label, 
  progress, 
  isComplete = false,
  isError = false
}) => {
  // Ensure progress is between 0-100
  const safeProgress = Math.max(0, Math.min(100, progress));
  
  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-1">
        <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-400">
          {isComplete ? 'Complete' : isError ? 'Error' : `${Math.round(safeProgress)}%`}
        </div>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
        <div 
          className={`h-2.5 rounded-full ${
            isError 
              ? 'bg-red-500' 
              : isComplete 
                ? 'bg-green-500' 
                : 'bg-blue-500'
          }`}
          style={{ width: `${safeProgress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
